import BlockRange from '@intercom/embercom-composer/blocks/block-range';
function AttributeReplacer(block) {
  this.block = block;
  this.attributes = block.get('config.attributes');
}
AttributeReplacer.prototype = {
  replaceAttributes(mutationResult) {
    let regex = /(#)?\{\{([^}]+)\}\}/g;
    this.originalText = this.block.get('text');
    this.newText = this.originalText;
    this.mutationResult = mutationResult;
    let offset = 0;
    let match;
    while (match = regex.exec(this.originalText)) {
      offset = this.processMatch(match, offset);
    }
    this.updateBlockText();
  },
  processMatch(match, offset) {
    let contents = match.pop();
    let escaped = match.pop();
    if (escaped) {
      return offset;
    }
    let parsedContents = this.parseContents(contents);
    let attribute = this.findAttribute(parsedContents.identifier);
    if (attribute) {
      return this.replaceAttribute(attribute, parsedContents.fallback, match, offset);
    }
    return offset;
  },
  findAttribute(identifier) {
    return this.attributes.findBy('templatable_identifier', identifier);
  },
  replaceAttribute(attribute, fallback, match, offset) {
    let name = attribute.get('name');
    let fullMatch = match.pop();
    let startIndex = match.index + offset;
    let endIndex = startIndex + name.length;
    let options = {
      fallback,
      identifier: attribute.get('templatable_identifier'),
      isApp: attribute.get('isApp'),
      noFallback: attribute.get('noFallback'),
      isEventMetadata: attribute.get('isUserEventMetadata'),
      isSelectedEventMetadata: attribute.get('isSelectedEventMetadata'),
      isUser: attribute.get('isUser') && !attribute.get('isUserEvent'),
      isUserEvent: attribute.get('isUserEvent'),
      isCompany: attribute.get('isCompany'),
      name
    };
    offset += name.length - fullMatch.length;
    let beforeMatch = this.newText.slice(0, startIndex);
    let afterMatch = this.newText.slice(startIndex);
    this.newText = beforeMatch + afterMatch.replace(fullMatch, name);
    this.updateEntities(startIndex, fullMatch.length, name.length);
    this.addAttribute(startIndex, endIndex, options);
    this.updateMutationResult(startIndex);
    return offset;
  },
  parseContents(contents) {
    if (contents.indexOf('|') === -1) {
      return {
        identifier: contents.trim(),
        fallback: null
      };
    } else {
      return this.parseContentsWithFallback(contents);
    }
  },
  parseContentsWithFallback(contents) {
    let contentsParts = contents.split('|');
    let identifier = contentsParts[0].trim();
    let fallback = this.parseFallback(contentsParts[1]);
    return {
      identifier,
      fallback
    };
  },
  parseFallback(fallback) {
    let fallbackKeywordRegex = /fallback\s*(:|=)/;
    let fallbackPlusFirstQuoteRegex = /\s*(fallback\s*(:|=)\s*("|'))/;
    fallback = this.trimSpaces(fallback);
    if (fallbackKeywordRegex.test(fallback)) {
      fallback = fallback.replace(fallbackPlusFirstQuoteRegex, '');
      return fallback.substring(0, fallback.length - 1);
    }
    return fallback.length ? fallback : null;
  },
  trimSpaces(text) {
    return text.replace(/^\s*|\s*$/g, '');
  },
  addAttribute(startIndex, endIndex, options) {
    let blockRange = BlockRange.atPositionIndex(startIndex, endIndex);
    this.block.toggleEntity('attribute', blockRange, options);
  },
  updateBlockText() {
    this.block.set('text', this.newText);
  },
  updateEntities(startIndex, matchLength, replacementLength) {
    this.block._updateEntitiesAfterInlineReplacement(startIndex, matchLength, replacementLength);
  },
  updateMutationResult(startIndex) {
    let newIndex;
    let mutationResult = this.mutationResult;
    let originalBlockText = this.originalText;
    let newBlockText = this.newText;
    if (mutationResult) {
      if (mutationResult.get('blockRange.startPoint.positionIndex') > startIndex + 1) {
        newIndex = mutationResult.get('blockRange.endPoint.positionIndex') - (originalBlockText.length - newBlockText.length);
      } else {
        newIndex = mutationResult.get('blockRange.endPoint.positionIndex') - 1;
      }
      mutationResult.set('blockRange', BlockRange.atPositionIndex(newIndex));
    }
  }
};
export default AttributeReplacer;